module.exports = __webpack_public_path__ + "img/Kendor.5597a35c.png";